var _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnNavListChapter = function SvgIcnNavListChapter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 11.4,
    r: 0.7,
    transform: "rotate(-90 7.9 11.4)",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 11.3601L34.5002 11.3601",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 17.4,
    r: 0.7,
    transform: "rotate(-90 7.9 17.4)",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 17.3601L34.5002 17.3601",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 23.4,
    r: 0.7,
    transform: "rotate(-90 7.9 23.4)",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 23.3601L34.5002 23.3601",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 29.4,
    r: 0.7,
    transform: "rotate(-90 7.9 29.4)",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 29.3601L34.5002 29.3601",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnNavListChapter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_nav_list_chapter.44faf219.svg";
export { ForwardRef as ReactComponent };